export enum prospectTypeEnum {
	contact = 'contact',
	account = 'account'
}
